var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpellCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_99",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1 22L9.85 17.75L11.25 16.35L14.1 19.2L19.75 13.55L21.15 14.95L14.1 22ZM3 16L7.85 3H10.2L15.05 16H12.75L11.6 12.7H6.35L5.2 16H3ZM7.05 10.8H10.95L9.05 5.4H8.95L7.05 10.8Z",
    fill: "#5434B6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpellCheck);
export default __webpack_public_path__ + "static/media/spellCheck.0c224ce4e3037283dbd0714405c29663.svg";
export { ForwardRef as ReactComponent };